import type { SVGProps } from "react";
export default function SvgChatbot(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-bot-message-square-icon lucide-bot-message-square"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 6V2H8" />
			<path d="M15 11v2" />
			<path d="M2 12h2" />
			<path d="M20 12h2" />
			<path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
			<path d="M9 11v2" />
		</svg>
	);
}
